import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const ParticipationPermsCallout = ({ show, forbiddenReason }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="callout warning participation-perms-callout">
      <div className="row">
        <div className="columns small-16">
          <h4>FREEZE! You cannot participate in this project...</h4>
          <p>Reason: { forbiddenReason }</p>
          <div>
            If you have questions, please <Link target="_blank" to="/help/contact/">get in touch</Link>.
          </div>
        </div>
      </div>
    </div>
  );
}

ParticipationPermsCallout.propTypes = {
  show: PropTypes.bool.isRequired,
  forbiddenReason: PropTypes.string
}

export default ParticipationPermsCallout;



// WEBPACK FOOTER //
// ./project/components/participation_perms_callout.jsx